import React, { Component } from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FILEPICKER_KEY } from '../constants';
import Select from './Select';
import actions from '../redux/actions';

class FileUploader extends Component {
  filepicker = null;

  constructor(props) {
    super(props);
    this.state = {
      files: [],
      dropzoneActive: false,
    };
  }

  componentDidMount() {
    this.filepicker = require('filepicker-js');
    this.filepicker.setKey(FILEPICKER_KEY);
  }

  onDragEnter() {
    this.setState({
      dropzoneActive: true,
    });
  }

  onDragLeave() {
    this.setState({
      dropzoneActive: false,
    });
  }

  onDrop(files, rejected) {
    // this.setState({
    //   dropzoneActive: false
    // });
    // this.props.hideAlert();
    // if(rejected.length) {
    //   this.props.alert('success', 'Please upload only .pdf, .doc and .docx files.');
    //   return;
    // }
    // this.filepicker.store(files[0], (FPFile) => {
    //   this.setState({file: FPFile});
    //   this.props.onUpload(FPFile);
    //   // this.props.alert('success', 'Upload successful!');
    // }, (FPError) => {
    //   console.error(FPError);
    //   this.props.alert('error', 'Oops! Your upload has failed. Please try again.');
    // });
  }

  _handleClick(e) {
    const { workTitles } = this.props;
    e.preventDefault();
    this.props.hideAlert();

    this.filepicker.pickMultiple(
      {
        // extensions: ['.pdf', '.doc', '.docx'],
        container: 'modal',
        openTo: 'COMPUTER',
      },
      (FPFiles) => {
        let files = [];
        for (let i = 0; i < FPFiles.length; i++) {
          if (i < workTitles.length) {
            files = [
              ...files,
              {
                file_url: FPFiles[i].url,
                file: FPFiles[i],
                work_title: '',
                work: null,
              },
            ];
          } else {
            break;
          }
        }

        if (FPFiles.length > workTitles.length) {
          this.props.hideAlert();
          this.props.alert(
            'error',
            `Please select ${workTitles.length} ${
              workTitles.length === 1 ? 'file' : 'files'
            }`
          );
        }

        this.setState({ files });
        // this.props.onUpload(FPFile);
        // this.props.alert('success', 'Upload success!');
      },
      (FPError) => {
        console.error(FPError);
        this.setState({ files: [] });
        // this.props.alert('error', 'Upload failed!');
      }
    );
  }

  _handleFileRemove(e, file) {
    e.preventDefault();

    const files = this.state.files.filter((item) => item.file_url !== file.url);

    this.setState({ files });
  }

  _handleWorkTitle(e, fileIndex) {
    let { files } = this.state;

    files[fileIndex]['work_title'] = e.target.value;

    this.setState({ files });
  }

  _handleUpload(e) {
    e.preventDefault();

    let { files } = this.state;

    if (files.length === 0) {
      this.props.alert('error', 'Please select files');
    }

    const checkedAll = files.every(({ work_title }) => work_title !== '');

    if (checkedAll) {
      let uploadFiles = [];
      files = files.forEach((file) => {
        uploadFiles = [
          ...uploadFiles,
          { file_url: file.file_url, work_title: file.work_title },
        ];
      });

      this.props.onUpload(uploadFiles);
    } else {
      this.props.alert('error', 'Please select work titles');
    }
  }

  render() {
    const { fileUpload, workTitles } = this.props;
    const { files, dropzoneActive } = this.state;
    const dropStyle = {
      opacity: dropzoneActive ? 0.6 : 1,
    };

    return (
      <div className="file-upload">
        <div
          className={cx({ 'upload-container': true, active: dropzoneActive })}
          onClick={(e) => this._handleClick(e)}
        >
          <Dropzone
            // accept=".pdf, .doc, .docx"
            multiple={true}
            disableClick={true}
            style={dropStyle}
            onDrop={(files, rejected) => {}}
            onDragEnter={() => this.onDragEnter()}
            onDragLeave={() => this.onDragLeave()}
          >
            {this.props.children ? (
              this.props.children
            ) : (
              <div className="drop-container">
                <div className="icon-container">
                  <div className="icon">
                    <FontAwesome name="plus" />
                  </div>
                </div>
                <div className="text">
                  <span className="text-gray">
                    {this.props.text || 'Upload File'}
                  </span>
                </div>
              </div>
            )}
          </Dropzone>
        </div>

        {files.length > 0 && (
          <div className="files-view">
            {files.map((item, fileIndex) => (
              <div key={fileIndex} className="uploaded-file">
                <span>{item.file.filename}</span>
                <Select
                  className="form-control"
                  value={item.work_title ? item.work_title : ''}
                  onChange={(e) => this._handleWorkTitle(e, fileIndex)}
                >
                  <option value="">Select Work Title</option>
                  {workTitles.map((work, index) => (
                    <option key={index} value={work.title}>
                      {work.title}
                    </option>
                  ))}
                </Select>
                <a
                  className="remove"
                  onClick={(e) => this._handleFileRemove(e, item.file)}
                >
                  <FontAwesome name="close" />
                </a>
              </div>
            ))}

            <button
              className="btn-upload"
              onClick={(e) => this._handleUpload(e)}
            >
              {fileUpload === 'start'
                ? 'Upload'
                : fileUpload === 'uploading'
                ? 'Uploading...'
                : 'Uploaded'}
            </button>
          </div>
        )}
      </div>
    );
  }
}

FileUploader.defaultProps = {
  children: null,
  fileUpload: 'start',
  workTitles: [],
};

FileUploader.propTypes = {
  children: PropTypes.node,
  fileUpload: PropTypes.string,
};

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
});

export default connect(null, mapDispatchToProps)(FileUploader);



// WEBPACK FOOTER //
// src/components/CregFileUploader.jsx